import { useCallback } from "react";
import { trpc } from "@lango/api";
import { useBot } from "@/api/useBot";

export const useTranscribe = () => {
  const { data: bot } = useBot();
  const {
    data,
    mutateAsync: mutateTranscribe,
    isLoading,
    reset,
  } = trpc.transcribe.useMutation();

  const transcribe = useCallback(
    async (audioData: string, prompt?: string) => {
      return mutateTranscribe({
        audioData: audioData,
        language: bot!.language,
        filePostfix: "m4a",
        prompt,
      });
    },
    [mutateTranscribe, bot?.language]
  );

  return {
    data,
    transcribe,
    isLoading,
    reset,
  };
};
